module.exports = __webpack_public_path__ + "img/lb-crossword.7a35186f.svg";